module.exports = __webpack_public_path__ + "img/logo.940ecc04.png";